<template>
  <form
    @submit.prevent="createByTemplate">
    <div class="d-flex w-100 justify-content-between">
      <h5 class="mb-1">{{ $t('Combine templates') }}</h5>
    </div>
    <p class="mb-1">{{ $t('Use global templates to create a new scorecard.') }}</p>
    <hr />
    <div class="form-group">
      <label for="interviewTemplate">{{ $t('Templates') }}</label>

      <ul
        v-if="selectedScoreforms.length > 0"
        class="list-group mb-3">
        <li
          v-for="(template, index) in selectedScoreforms"
          :key="index"
          class="list-group-item">
          <div class="d-flex justify-content-between">
            <div>{{ template.name }}</div>
            <a
              href="javascript:void(0)"
              type="button"
              @click="removeItem(index)">
              {{ $t('Remove') }}
            </a>
          </div>
        </li>
      </ul>

      <select
        @change="insertItem"
        class="form-control">
        <option value="">-- Selecione --</option>
        <option
          v-for="template in anotherTemplates"
          :key="template._id"
          :value="template._id">
          {{ template.name }}
        </option>
      </select>
    </div>

    <button
      type="button"
      class="btn btn-primary"
      @click="next">{{ $t('Generate scorecard') }}</button>
    <button
      type="button"
      class="btn btn-light"
      @click="back">{{ $t('To go back') }}</button>
  </form>
</template>

<script>
export default {
  name: 'ScoreformFormOptions',
  components: {
  },
  props: {
  },
  data () {
    return {
      loading: true,
      templates: [],
      selected: [],
      items: 1
    }
  },
  computed: {
    selectedScoreforms () {
      return this.selected.map(item => {
        return this.templates.find(template => template._id === item._id)
      })
    },
    anotherTemplates () {
      return this.templates.filter(template => {
        return !this.selected.map(item => item._id).includes(template._id)
      })
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.loading = true

      const params = {
        sort: 'name',
        limit: 1000
      }

      this.$store
      .dispatch('getScoreforms', params)
      .then((result) => {
        this.templates = result.docs
        this.loading = false
      })
    },
    createByTemplate (event) {
      const id = event.target.value
      const scoreform = this.templates.find(template => template._id === id)
      if (scoreform) {
        this.$emit('input', {
          name: scoreform.name,
          groups: scoreform.groups
        })
      }
    },
    back () {
      this.$emit('back')
    },
    insertItem (event) {
      const id = event.target.value
      const doc = this.templates.find(template => template._id === id)
      if (doc) {
        this.selected.push(doc)
        event.target.value = ''
      }
    },
    removeItem (index) {
      this.selected.splice(index, 1)
    },
    next () {
      const groups = []
      this.selected.forEach(item => {
        item.groups.forEach(group => {
          groups.push({
            name: group.name,
            questions: group.questions
          })
        })
      })

      this.$emit('input', {
        name: this.selectedScoreforms.map(item => item.name).join(', '),
        groups
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Job/JobProfile/JobProfileScoreformsOptionsTemplate.vue